export type Notification = {
  message: string;
  variant?: 'basic' | 'success' | 'warning' | 'error' | 'highlight';
  icon?: string;
  lifetime?: number;
};

export async function notify(notification: Notification) {
  // @ts-ignore
  const { renderNotification } = await import(/* @vite-ignore */ '@oneweb/notification');

  renderNotification(notification);
}
